import { WithLatencyMeasurement } from './latency-measurement';
import { WithIma } from './ima/ima';
export const WebAdapterName = {
    Bitmovin: 'bitmovin',
    Shaka: 'shaka',
};
const getAdapterModule = (Adapter) => {
    const AdapterWithLatencyMeasurement = WithLatencyMeasurement(Adapter);
    return {
        Adapter: AdapterWithLatencyMeasurement,
        AdapterWithIma: WithIma(AdapterWithLatencyMeasurement),
    };
};
export const getWebAdapters = () => {
    return {
        [WebAdapterName.Bitmovin]: () => (import('@zattoo/playback-sdk/adapter/bitmovin').then((module) => (getAdapterModule(module.BitmovinAdapter)))),
        [WebAdapterName.Shaka]: () => (import('@zattoo/playback-sdk/adapter/shaka').then((module) => (getAdapterModule(module.ShakaAdapter)))),
    };
};
